import segment from "../../api/segment";
import { perPageCount } from "@/common/constants";
import {
  dummyRows,
  percentageVieW,
  convertCount,
  capitalizeFirstLetter,
} from "@/common/functions";
const chartConfigs = () => import("@/components/Charts/config");

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      per_page_count: perPageCount,
      segment: "",
      sort_field: "id",
      sort_order: "desc",
    },
    totalItems: 0,
    listData: [],
    listItems: false,
    tags: [],
    senderIdData: [],
    campignsData: [],
    subscribersList: [],
    subscribersListCount: 0,
    listCountData: [],
    allListCountSummery: [],
    allListPerfomance: [],
    listPerformanceData: [],
    domainAnalytics: [],
    deviceAnalytics: [],
    total: 0,
    busyLoaderStatus: true,
    selectedListNames: [],
    segmentName: "",
    userType: 1,
    customLoad: false,
    customPropertyData: [],
    customLimit: 1,
    allowMailboxProvider: 1,
    segmentSummery: "",
    segmentAnalyticsLoading: false,
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    return state.items.map((item) => {
      if (item._showDetails) {
        return item;
      }
      return {
        id: item.id,
        seg_num: item.segNum,
        name: {
          title: item.name,
          text: item.modifieddate,
          loading: parseInt(item.isSave) === 5,
          tooltipTitle: parseInt(item.isSave) === 5 ? "Updating" : "",
        },
        seg_list: item.listnames,
        seg_activeCount: { count: item.activeCount, loading: item.isSave },
        seg_actions: {},
      };
    });
  },
  getSubscribersListCount: (state) => {
    if (state.subscribersListCount) {
      return parseInt(state.subscribersListCount);
    }
    return 0;
  },

  getListsData: (state) => {
    var listData = [];
    var items = [];
    var listNames = [];

    if (state.listData) {
      state.listData.forEach(function (entry) {
        listData.push(entry.id);
        listNames.push(entry.listname);
        items.push({
          rec_check: entry.id,
          rec_name: entry.listname,
          rec_last_updated: entry.modifieddate,
          rec_count: entry.active,
        });
      });
    }

    return { list: listData, items: items, listNames: listNames };
  },

  getTags: (state) => {
    return state.tags.map((tag) => {
      return { value: tag.id, label: tag.tagName };
    });
  },

  getSenderIds: (state) => {
    var listData = [];
    var selectSender = 0;

    if (state.senderIdData) {
      state.senderIdData.forEach(function (entry) {
        if (!selectSender) {
          selectSender = entry.senderId;
        }

        listData.push({ value: entry.senderId, label: entry.senderEmail });
      });
    }

    return { subsciberSenderid: listData, selectSender: selectSender };
  },
  getCampaignLists: (state) => {
    var listData = [];
    var type = "";
    if (state.campignsData) {
      state.campignsData.forEach(function (entry) {
        type = "";
        if (entry.type === 2) {
          type = " - A Campaign";
        } else if (entry.type === 3) {
          type = " - B Campaign";
        }
        listData.push({
          value: entry.id,
          label: "ID-" + entry.campNum + ":" + entry.campName + type,
        });
      });
    }

    return listData;
  },
  getSubscribersListData: (state) => {
    var array = [];

    if (!state.subscribersList) {
      return dummyRows();
    }
    var statusType = "circle-check";
    if (state.subscribersList) {
      state.subscribersList.forEach(function (entry) {
        switch (entry.status) {
          case "Active":
            statusType = "circle-check";
            break;
          case "Unknown":
            statusType = "unknown";
            break;
          case "External verified":
            statusType = "external-verified";
            break;
          case "Suppressed":
            statusType = "light-blue";
            break;
          case "Unsubscribe":
            statusType = "circle-close";
            break;
          case "Spam":
            statusType = "circle-red";
            break;
          case "Bounced":
            statusType = "circle-yellow";
            break;
          case "External group mailbox":
            statusType = "external-group-mailbox";
            break;
          case "Spam Trap":
            statusType = "red";
            break;
          case "External abusers":
            statusType = "external-abusers";
            break;
          case "External invalid":
            statusType = "external-invalid";
            break;
          case "Spam complaints":
            statusType = "spam-complains";
            break;
          case "Frequent abusers":
            statusType = "frequent-abusers";
            break;
          default:
            statusType = "circle-check";
        }

        array.push({
          rec_sl_no: entry.slno,
          rec_email: entry.email,
          rec_rating: {
            rating: entry.rating,
            isIndicatorActive: false,
            style: {
              fullStarColor: "#007BFF",
              emptyStarColor: "#ccd6e3",
              starWidth: 17,
              starHeight: 17,
            },
          },
          rec_name: entry.name,
          rec_status: {
            text: entry.status === "Active" ? "Valid" : entry.status,
            type: statusType,
          },
          table_action: entry.id,
        });
      });
    }

    return array;
  },

  getListSummery: (state) => {
    var count1 = [];
    var count2 = [];
    var i = 1;
    if (state.listCountData) {
      state.listCountData.forEach((entry) => {
        for (var key in entry) {
          var keys = key.replace("_", " ");
          keys = capitalizeFirstLetter(
            keys === "active contacts" ? "valid" : keys
          );
          if (count1.length >= 2) {
            count2.push({
              text: keys,
              value: convertCount(entry[key]),
              legClass: "bg-" + i,
            });
          } else {
            count1.push({
              text: keys,
              value: convertCount(entry[key]),
              legClass: "bg-" + i,
            });
          }
          i = i + 1;
        }
      });
    }

    return [count1, count2];
  },
  geListPerfomance: (state) => {
    var count1 = [];
    var count2 = [];
    var listCounts = [];
    var loading = true;
    var i = 1;
    for (var key in state.listPerformanceData) {
      loading = false;
      if (key !== "total" && key !== "activeCnt") {
        var keys = capitalizeFirstLetter(key.replace("_", " "));
        if (count1.length >= 2) {
          count2.push({
            text: keys,
            value: convertCount(state.listPerformanceData[key]),
            legClass: "bg-" + i,
          });
        } else {
          count1.push({
            text: keys,
            value: convertCount(state.listPerformanceData[key]),
            legClass: "bg-" + i,
          });
        }
        i = i + 1;
        listCounts.push(state.listPerformanceData[key]);
      }
    }

    var chartSummery = {
      labels: ["Opens", "Non-openers", "Clicks", "Conversions"],
      datasets: [
        {
          label: "Data One",
          backgroundColor: ["#03045E", "#023E8A", "#0096C7", "#48CAE4"],
          data: listCounts,
        },
      ],
      extraOptions: chartConfigs.pieChartOptions,
    };

    return { list: [count1, count2], graph: chartSummery, loading: loading };
  },
  getAllListPerfomance: (state) => {
    var active = state.listPerformanceData["activeCnt"];
    var array = [];
    for (var key in state.listPerformanceData) {
      if (key !== "total" && key !== "activeCnt") {
        var keys = capitalizeFirstLetter(key.replace("_", " "));
        var percnt = percentageVieW(state.listPerformanceData[key], active);
        if (keys === "Non openers") {
          percnt = percentageVieW(state.listPerformanceData[key], active);
        } else if (keys === "Clicks") {
          percnt = percentageVieW(
            state.listPerformanceData[key],
            state.listPerformanceData["opens"]
          );
        } else if (keys === "Conversions") {
          percnt = percentageVieW(
            state.listPerformanceData[key],
            state.listPerformanceData["clicks"]
          );
        }
        array.push({
          status: keys,
          percentage: percnt + "%",
          counts: convertCount(state.listPerformanceData[key]),
        });
      }
    }

    return array;
  },
  getAllListCountSummery: (state) => {
    var array = [];
    var listCounts = [];
    var loading = true;

    if (state.allListCountSummery) {
      loading = false;
      var Total = state.allListCountSummery["total_contact"];

      for (var key in state.allListCountSummery) {
        var keys = key.replace(/_/gi, " ");

        if (key) {
          var logArray = ["active_contacts", "Unknown", "bounced", "spamtrap"];
          if (
            key !== "total_contact" &&
            logArray.indexOf(key) !== -1 &&
            listCounts.length <= 5
          ) {
            listCounts.push(state.allListCountSummery[key]);
          }
        }
        keys = capitalizeFirstLetter(
          keys === "active contacts" ? "valid" : keys
        );
        array.push({
          status: keys,
          percentage:
            percentageVieW(state.allListCountSummery[key], Total) + "%",
          counts: convertCount(state.allListCountSummery[key]),
        });
      }
    }

    var chartSummery = {
      labels: ["Valid", "Unknown", "Bounced", "Spam trap"],
      datasets: [
        {
          label: "Data One",
          backgroundColor: ["#03045E", "#023E8A", "#48CAE4", "#0096C7"],
          data: listCounts,
        },
      ],
      extraOptions: chartConfigs.pieChartOptions,
    };

    return { list: array, graph: chartSummery, loading: loading };
  },

  getSegmentDomainAnaltics: (state) => {
    var count1 = [];
    var count2 = [];
    var listArr = [];
    var smtpDmn = [];
    var listCounts = [];
    var totalDevices = 0;
    var loading = true;
    if (state.domainAnalytics && state.domainAnalytics.smtpDomain) {
      loading = false;
      totalDevices = state.domainAnalytics.list_count;
      var smtpDomain = state.domainAnalytics.smtpDomain;
      listCounts.push(smtpDomain.gmail ? smtpDomain.gmail : 0);
      listCounts.push(smtpDomain.hotmail ? smtpDomain.hotmail : 0);
      listCounts.push(smtpDomain.yahoo ? smtpDomain.yahoo : 0);
      listCounts.push(smtpDomain.others ? smtpDomain.others : 0);
      count1.push({
        text: "Gmail",
        value: convertCount(smtpDomain.gmail ? smtpDomain.gmail : 0),
        legClass: "bg-1",
      });
      count1.push({
        text: "Yahoo",
        value: convertCount(smtpDomain.yahoo ? smtpDomain.yahoo : 0),
        legClass: "bg-3",
      });
      count2.push({
        text: "Hotmail",
        value: convertCount(smtpDomain.hotmail ? smtpDomain.hotmail : 0),
        legClass: "bg-2",
      });
      count2.push({
        text: "Other Domains",
        value: convertCount(smtpDomain.others ? smtpDomain.others : 0),
        legClass: "bg-4",
      });
      smtpDmn = [count1, count2];
      var toalActive = state.domainAnalytics.totalActive;

      for (var keys in state.domainAnalytics.data) {
        listArr.push({
          status: keys,
          percentage:
            percentageVieW(state.domainAnalytics.data[keys], toalActive) + "%",
          counts: convertCount(state.domainAnalytics.data[keys]),
        });
      }
    }

    var chartSummery = {
      labels: ["Gmail", "Hotmail", "Yahoo", "Other Domains"],
      datasets: [
        {
          label: "Data One",
          backgroundColor: ["#03045E", "#023E8A", "#0096C7", "#48CAE4"],
          data: listCounts,
        },
      ],
      extraOptions: chartConfigs.pieChartOptions,
    };

    return {
      loading: loading,
      smtpDomain: smtpDmn,
      listArr: listArr,
      graph: chartSummery,
      totalDevices: totalDevices,
    };
  },
  getDeviceAnalytics: (state) => {
    var listCounts = [];
    var osArr = [];
    var arr1 = [];
    var arr2 = [];
    var totalCount = 0;
    var loading = true;
    var i = 1;

    if (state.deviceAnalytics && state.deviceAnalytics[0]) {
      loading = false;
      var result = state.deviceAnalytics[0];

      result.forEach(function (entry) {
        totalCount = parseInt(totalCount + entry.count);
        listCounts.push(entry.count);

        if (arr1.length >= 2) {
          arr2.push({
            text: entry.device,
            value: convertCount(entry.count),
            legClass: "bg-" + i,
          });
        } else {
          arr1.push({
            text: entry.device,
            value: convertCount(entry.count),
            legClass: "bg-" + i,
          });
        }
        i = i + 1;
      });
      if (!totalCount) {
        arr1 = [];
        arr2 = [];
        arr1.push({ text: "Desktop", value: 0, legClass: "bg-1" });
        arr1.push({ text: "Mobile", value: 0, legClass: "bg-2" });
        arr2.push({ text: "Console", value: 0, legClass: "bg-3" });
        arr2.push({ text: "Other", value: 0, legClass: "bg-4" });
      }

      var osDetls = state.deviceAnalytics[1];
      osDetls.forEach(function (entry) {
        osArr.push({
          status: entry.os.replace("_", " "),
          percentage: entry.percentage + " %",
          counts: convertCount(entry.cnt),
        });
      });
    }

    var chartSummery = {
      labels: ["Desktop", "Mobile", "Console", "Others"],
      datasets: [
        {
          label: "Data One",
          backgroundColor: ["#03045E", "#023E8A", "#0096C7", "#48CAE4"],
          data: listCounts,
        },
      ],
      extraOptions: chartConfigs.pieChartOptions,
    };

    return {
      loading: loading,
      devices: [arr1, arr2],
      deviceslist: osArr,
      graph: chartSummery,
      totalDevices: totalCount,
    };
  },
  getCustomProperty: (state) => {
    var cutomArray = [];
    state.customPropertyData.map((item) => {
      cutomArray.push({
        value: Number.isInteger(item.id)
          ? item.id + "_" + item.fieldType + "_custom_field"
          : item.id,
        label: item.fieldName,
        type: Number.isInteger(item.id) ? item.fieldType : "",
      });
    });
    return cutomArray;
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count ||
      filter.segment !== params.segment ||
      filter.sort_field !== params.sort_field ||
      filter.sort_order !== params.sort_order
    ) {
      commit("setFilter", { ...params });
      return new Promise(function (resolve) {
        segment.fetchItems(params, (data) => {
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      });
    }
  },

  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },

  deleteSegment({ dispatch }, { id }) {
    return segment.delete(id).then(function () {
      dispatch("refreshItems");
    });
  },

  refreshSegment({ commit, state, dispatch }, { id, index }) {
    commit("setBusyLoaderStatus", false);
    var items = state.items;
    items[index] = { _showDetails: true };
    commit("setItems", { items: [...items] });
    return segment.refresh(id).then(function () {
      dispatch("refreshItems");
    });
  },

  getLists({ commit, state }) {
    if (!state.listItems) {
      commit("setListItems", true);
      commit("setUserType", 0);
      segment.getLists((data) => {
        commit("setAllLists", { items: data.lists });
        commit("setUserType", data.user_type);
        commit("setSenderIds", { items: data.senderids });
        commit("setTags", { items: data.tags });
      });
    }
  },
  saveSegment(_, params) {
    return segment.saveSegment(params);
  },

  getCampaigns({ commit }, params) {
    segment.getCampaigns(params, (data) => {
      commit("setCampaignData", { items: data.names });
    });
  },
  editSegment(_, params) {
    return segment.editSegment(params);
  },

  getSubscribersFromList({ commit }, params) {
    segment.getSubscribersFromList(params, (data) => {
      commit("setSubscribersList", { items: data.report_data });
      commit("setSubscribersListCount", { items: data.listcount });
    });
  },
  getListData({ commit }, params) {
    commit("setSegmentAnalyticsLoading", true);
    segment.getListData(params, (data) => {
      commit("setSegmentAnalyticsLoading", false);
      commit("setListCountData", { items: data.contact_summery });
      commit("setAllListCountSummery", { items: data.all_contact_summery });
      commit("setListPerformance", { items: data.list_performance });
      commit("setListAnalyticsData", { items: data.domain_analytics });
      commit("setDeviceDetails", { items: [data.devices, data.os] });
      commit("setSegmentName", data.segmentName);
    });
  },
  refreshStoredData({ commit }) {
    commit("setListCountData", {});
    commit("setAllListCountSummery", {});
    commit("setListPerformance", {});
    commit("setListAnalyticsData", {});
    commit("setDeviceDetails", {});
    commit("setSubscribersList", {});
    commit("setSubscribersListCount", {});
  },
  resetState({ commit }) {
    commit("resetState");
  },
  fetchCustomProperty({ commit, state }) {
    if (!state.customLoad) {
      segment.fetchCustomProperty((data) => {
        commit("setCustomProperty", data);
        commit("setCustomLimit", data.limit);
        commit("setAllowMailboxProvider", data.allowMailboxProvider);
        commit("setCustomLoad", true);
      });
    }
  },
};

// mutations
const mutations = {
  setCustomLimit(state, data) {
    state.customLimit = data;
  },
  setAllowMailboxProvider(state, data) {
    state.allowMailboxProvider = data;
  },
  setCustomProperty(state, { data }) {
    state.customPropertyData = data;
  },
  setCustomLoad(state, data) {
    state.customLoad = data;
  },
  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setAllLists(state, { items }) {
    state.listData = items;
  },
  setUserType(state, data) {
    state.userType = data;
  },
  setSenderIds(state, { items }) {
    state.senderIdData = items;
  },
  setTags(state, { items }) {
    state.tags = items;
  },

  setCampaignData(state, { items }) {
    state.campignsData = items;
  },
  setSubscribersList(state, { items }) {
    state.subscribersList = items;
  },
  setSubscribersListCount(state, { items }) {
    state.subscribersListCount = items;
  },
  setListCountData(state, { items }) {
    state.listCountData = items;
  },
  setSegmentAnalyticsLoading(state, val) {
    state.segmentAnalyticsLoading = val;
  },
  setAllListCountSummery(state, { items }) {
    state.allListCountSummery = items;
  },
  setListPerformance(state, { items }) {
    state.listPerformanceData = items;
  },
  setListAnalyticsData(state, { items }) {
    state.domainAnalytics = items;
  },
  setDeviceDetails(state, { items }) {
    state.deviceAnalytics = items;
  },
  setTotal(state, total) {
    state.total = total;
  },
  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setListItems(state, loaded) {
    state.listItems = loaded;
  },
  setSelectedListnames(state, data) {
    state.selectedListNames = data;
  },
  setSegmentName(state, data) {
    state.segmentName = data;
  },
  setSegmentSummery(state, data) {
    state.segmentSummery = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
